<template>
  <div>
    <div v-if="$auth.policies['meal-report']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Báo cáo suất ăn"
            :link="[
              {
                text: 'Báo cáo suất ăn',
                href: '../meal-report'
              }
            ]"
          />
        </div>
        <div v-if="onFiltered && !loading">
          <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
            <v-icon left>mdi-file-excel</v-icon> Xuất Excel
          </v-btn>
        </div>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <MealReportFilter @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card
        v-if="!onFiltered"
        class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16 px-6"
        outlined
      >
        Vui lòng cung cấp thông tin ở trên, sau đó ấn [Tìm kiếm] để xem Báo cáo suất ăn
      </v-card>
      <v-card v-show="onFiltered" outlined class="mx-4 elevation-0">
        <MealReportDataTable ref="table" />
      </v-card>
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import utils from '@/plugins/utils'
import MealReportDataTable from '@/modules/mealReport/MealReportDataTable.vue'
import MealReportFilter from '@/modules/mealReport/MealReportFilter.vue'
import moment from 'moment'

export default {
  components: {
    Breadcrumbs,
    MealReportDataTable,
    MealReportFilter
  },
  props: {},
  data() {
    return {
      newDialog: false,
      type: '',
      onFiltered: false
    }
  },
  computed: {
    ...mapState('MealReport', ['loading', 'studentMenuSearchParams', 'selectedSlot'])
  },
  methods: {
    ...mapActions('MealReport', ['getStudentMealReportIndependent']),
    async refresh(query) {
      this.onFiltered = true
      this.$refs.table.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    },

    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.table.headers]
        headers.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'actions')
        // thêm cột "Bữa ăn" (báo cáo theo bữa đang lọc; bỏ chọn bữa -> "Tất cả bữa") ngay sau Ngày sinh
        const slotTitle = get(this.selectedSlot, 'title') || 'Tất cả bữa'
        const dobIdx = excelHeader.findIndex(h => h.value === 'dob')
        excelHeader.splice(dobIdx + 1, 0, { text: 'Bữa ăn', value: 'mealSlot' })
        const filters = this.$options.filters

        const studentMeals = await this.getStudentMealReportIndependent()
        const list = []
        for (const item of studentMeals) {
          const s = { ...item }
          s.code = filters.getStudentCode(item.student.code)
          s.dob = filters.ddmmyyyy(item.student.dob)
          s.class = get(item, 'student.currentClass.title')
          s.student = item.student.name
          s.mealSlot = slotTitle
          list.push(s)
        }

        const month = moment(this.studentMenuSearchParams.time).month() + 1
        utils.exportExcel(list, excelHeader, `BaoCaoSuatAn_Thang${month}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  created() {
    this.onFiltered = false
  }
}
</script>
<style scoped></style>
